// extracted by mini-css-extract-plugin
module.exports = {"main":"navbar_main__2NJ8B","nav__items":"navbar_nav__items__3_6SB","img":"navbar_img__3MwYk","logo_text":"navbar_logo_text__ixF3f"};